import type * as React from 'react';

import { cn } from '../utils';
import { Icons } from './icons';

interface EmptyPlaceholderProps extends React.HTMLAttributes<HTMLDivElement> {}

export function EmptyPlaceholder({ className, children, ...props }: EmptyPlaceholderProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-md border border-dashed text-center animate-in fade-in-50',
        className,
      )}
      {...props}
    >
      <div className='mx-auto flex flex-col items-center justify-center text-center'>
        {children}
      </div>
    </div>
  );
}

interface EmptyPlaceholderIconProps extends React.HTMLAttributes<SVGElement> {
  name: keyof typeof Icons;
}

export function EmptyPlaceHolderIcon({
  name,
  className,
  children,
  ...props
}: EmptyPlaceholderIconProps) {
  const Icon = Icons[name];

  if (!Icon) {
    return null;
  }

  return (
    <div className='flex h-20 w-20 items-center justify-center rounded-full bg-muted'>
      <Icon className={cn('h-10 w-10', className)} {...props} />
    </div>
  );
}

interface EmptyPlacholderTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {}

export function EmptyPlaceholderTitle({ className, title, ...props }: EmptyPlacholderTitleProps) {
  return (
    <h2 className={cn('mt-6 text-xl font-semibold', className)} {...props}>
      {title}
    </h2>
  );
}

interface EmptyPlacholderDescriptionProps extends React.HTMLAttributes<HTMLParagraphElement> {}

export function EmptyPlaceholderDescription({
  className,
  title,
  children,
  ...props
}: EmptyPlacholderDescriptionProps) {
  return (
    <div className='flex flex-col items-center justify-center gap-2'>
      <p
        className={cn(
          'mb-8 mt-2 text-center text-sm font-normal leading-6 text-muted-foreground',
          className,
        )}
        {...props}
      >
        {title}
      </p>
      {children}
    </div>
  );
}
